import { useApplicationModals } from "app/common/hooks";
import { FormHeader } from "app/components/atoms/layout";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import { InputMolecule } from "app/components/molecules/form";
import { useCollector } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { defaultReportStart, defaultReportEnd } from "app/common/reportDateRange";

const breadcrumbItems = [
  { label: "Reports", href: "#" },
  { label: "Top Customers", href: "#" },
];

function TopCustomer() {
  const navigate = useNavigate();
  const { openModal, setPayloads } = useApplicationModals();
  const [query, setQuery] = useState("");
  const [start, setStart] = useState(defaultReportStart());
  const [end, setEnd] = useState(defaultReportEnd());

  const handleStartChange = (e) => setStart(e.target.value);
  const handleEndChange = (e) => setEnd(e.target.value);

  const handleQueryChange = (e) => setQuery(e.target.value);
  const [reports, setReport, loader, collect] = useCollector({
    modelName: "report",
    methodName: "topCustomer",
  });

  useEffect(() => {
    if (start && end && start != "" && end != "") {
      collect({ start, end });
    }
  }, [start, end]);

  useEffect(() => {
    collect({ dailyOmzet_search: query });
  }, [query.length >= 3]);

  return (
    <MainLayout
      activeSidebarNavigation="report"
      activeSidebarChild="top-customer"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Top Customers"
    >
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <FormHeader appearance="none">
              <InputMolecule testId="report-top-customer-dari-tanggal-input"
                label="Dari Tanggal"
                placeholder="Dari Tanggal"
                type="date"
                value={start}
                onChange={handleStartChange}
              />
              <InputMolecule testId="report-top-customer-hingga-tanggal-input"
                label="Hingga Tanggal"
                placeholder="Hingga Tanggal"
                type="date"
                value={end}
                onChange={handleEndChange}
              />
            </FormHeader>
          </Table.SearchBarWrapper>
          {/* <Table.UtilitiesButtonWrapper>
            <IconButton testId="report-top-customer-printer-button" icon={PrinterIcon} />
          </Table.UtilitiesButtonWrapper> */}
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Nama Customer</Table.Heading>
              <Table.Heading align="right">Transaksi Lunas</Table.Heading>
              <Table.Heading align="right">Total Omzet</Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {reports?.map((dailyOmzet, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>{dailyOmzet?.customer_name}</Table.Cell>
                <Table.Cell align="right"><Typography.Currency fontSize="base" type="number" number={dailyOmzet?.done_transaction}/></Table.Cell>
                <Table.Cell align="right"><Typography.Currency fontSize="base" type="number" number={dailyOmzet?.done_payment}/></Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default TopCustomer;
